export function distanceSquareRoot(a, b) {
    return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]));
}
//# sourceMappingURL=distance-square-root.js.map